import { FunctionComponent } from "react";
import _ from 'lodash';
        
interface ITermsAndConditionsProps {
    register: Function;
    containerStyles?: string;
    labelStyles?: string;
    error?: any;
}

const TermsAndConditions: FunctionComponent<ITermsAndConditionsProps> = ({ register, containerStyles, labelStyles, error }) => {
    const labelText = "Terms And Conditions";
    const fieldName = _.camelCase(labelText?.replaceAll(' ', ''));
    
    return (
        <div className={`${containerStyles} flex items-center justify-center cursor-pointer my-4`}>
            <input 
                type="checkbox" 
                className="form-checkbox h-3 w-3 accent-primary cursor-pointer" 
                {...register(fieldName)} 
            />
            <label className={`text-gray-900 font-medium ml-4 text-xl ${labelStyles}`}>
                <a 
                    className="text-primary hover:underline" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    href="https://www.dropbox.com/scl/fi/ueb58s7eli31z6jfry3ke/ToS.pdf?rlkey=nq3erxn19cj0x808l7fapfb7t&st=aaexcp2s&dl=0"
                >
                    {labelText}
                </a>
            </label>
            {error && <p className='text-sm text-red-600 mb-3'>{ `${error}` }</p>}
        </div>
    )
}

export default TermsAndConditions;